export function zplRendererWorker() {
    if (typeof Worker !== 'undefined') {
        return new Worker(new URL(`./zpl-renderer.worker`, import.meta.url), {
            type: 'module',
        });
    } else {
        return null;
    }
}
